// import { isDesktop } from "react-device-detect";
import { COMPONENTS } from '../../lib/constants';

export const LogoView = {
	name: COMPONENTS.LOGO,
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'logo',
			type: 'Sprite',
			components: [
				{
					name: 'logo',
					type: 'Sprite',
					img: 'logo',
					position: {
						x: 0,
						y: 0
					}
				}
			]
		}
	]
};
